"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WORKFLOW_ACTION;
(function(WORKFLOW_ACTION) {
  WORKFLOW_ACTION["START"] = "start";
  WORKFLOW_ACTION["STOP"] = "stop";
  WORKFLOW_ACTION["SMART_SCHEDULE"] = "smart_schedule";
  WORKFLOW_ACTION["SKIP"] = "skip_wf";
})(
  (WORKFLOW_ACTION = exports.WORKFLOW_ACTION || (exports.WORKFLOW_ACTION = {}))
);
//# sourceMappingURL=IGroupWorkflowModel.js.map
